/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
} from '../../../_metronic/partials/widgets'
import { NewsDashboard } from './components/NewsDashboard'
import { JobsDashboard } from './components/JobsDashboard'
import JobConfirmationsDashboard from './components/JobConfirmationsDashboard'
import CompanyConfirmationsDashboard from './components/CompanyConfirmationsDashboard'
import { useAuth } from '../../modules/auth'
import { GetRoleAsyncOutputItem } from '../../modules/base-definitions/components/roles/core/dto/getRoleAsyncOutput'
import { PermissionName } from '../../modules/auth/core/_permission'

interface DashboardPageProps {
  permissions?: GetRoleAsyncOutputItem[];
}
const DashboardPage: FC<DashboardPageProps> = ({permissions}) => (
  <>
    <div className='row g-5 gx-xxl-8'>
      {
        permissions?.some(x => x.name === PermissionName.GraduatedPanel) ?
          <>
            <div className='col-xxl-12'>
              {<NewsDashboard />}
            </div>
            <div className='col-xxl-12'>
              {<JobsDashboard />}
            </div> 
          </>: 
          <></>
      }
       {
        permissions?.some(x => x.name === PermissionName.CompanyMonitoring) ?
          <>
            <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
              <CompanyConfirmationsDashboard />
            </div>
            <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
              <JobConfirmationsDashboard />
            </div>
          </>
          :<></>
      }
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const { currentUser } = useAuth();
  const permissions = currentUser?.result?.permissions;
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage permissions={permissions} />
    </>
  )
}

export { DashboardWrapper }
